<template>
  <component :is="iconSvg"></component>
</template>
<script>
import { shallowRef, watch } from 'vue'
import getKebabName from 'nette-base-module/js/utils/getKebabName'
const icons = {}

export function loadIcons(requireContext) {
  // Make sure require.context was created with lazy mode
  const isLazy = typeof requireContext.id === 'string' && requireContext.id.includes('lazy')

  const componentFiles = requireContext.keys()

  return componentFiles.map((file) => {
    const name = getKebabName(file)

    if (isLazy) {
      icons[name] = async function () {
        const icon = await requireContext(file)
        return icon.default || icon
      }
    } else {
      const icon = requireContext(file)
      icons[name] = icon.default || icon
    }

    // Return the loaded icon name
    return name
  })
}

export default {
  props: {
    icon: String,
  },
  setup(props) {
    let iconSvg = shallowRef(null)

    watch(
      () => props.icon,
      (icon) => {
        if (typeof icons[icon] === 'undefined') {
          // vykreslime otaznik?
          console.log('Icon not found', icon)
          iconSvg.value = null
        } else if (typeof icons[icon] === 'function') {
          iconSvg.value = { template: icons[icon].call(null) }
        } else {
          iconSvg.value = { template: icons[icon] }
        }
      },
      { immediate: true }
    )

    return {
      iconSvg,
    }
  },
}
</script>
